import { ThemeProps, MediaQueries } from '@hhgtech/hhg-components'
import styled from 'styled-components'

export const StyledFeedbackPopup = styled.div`
  position: fixed;
  z-index: 15;
  right: 50%;
  bottom: 0;
  display: none;
  width: 100vw;
  max-height: 100vh;
  background: white;
  border-radius: 16px 16px 0 0;

  line-height: 1.2;

  opacity: 0;
  overflow-y: auto;
  pointer-events: none;
  transform: translateX(50%);
  transition: opacity 0.3s ease-in;

  ${MediaQueries.mbUp} {
    right: 50%;
    bottom: 50%;
    transform: translate(50%, 50%);
    width: 90vw;
    min-width: 250px;
    max-width: 550px;
    border-radius: 16px;
  }

  &[data-show='true'] {
    display: unset;
    opacity: 1;
    pointer-events: auto;
  }
`

export const StyledModalTop = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1.2rem;

  background-color: ${(props: ThemeProps) => props.theme.mbColors.lightGray};
`
export const StyledModalContent = styled.div`
  padding: 0 24px 24px;

  > div:not(:last-child) {
    border-bottom: 1px solid
      ${(props: ThemeProps) => props.theme.mbColors.lightGray};
  }
`
export const StyledQuestionContainer = styled.div``
export const StyledQuestionTopContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
  cursor: pointer;
`
export const StyledQuestionHeading = styled.div`
  display: flex;
  align-items: center;
  .question-icon {
    margin-right: 0.5rem;
  }
  .question-title {
    font-weight: 600;
  }
`
export const StyledQuestionContent = styled.div`
  overflow: hidden;
  height: 0;
  transition: height 0.4s ease;
`
export const StyledQuestionWrapper = styled.div`
  padding-bottom: 0.5rem;

  .textarea-container {
    width: 100%;
    min-height: 124px;
  }

  .question-warningtext {
    padding: 1rem 0;
  }
`
export const StyledSubmitContainer = styled.div`
  padding: 16px 0 0;
  button {
    margin-left: auto;
    &:disabled,
    [disabled] {
      background: ${(props: ThemeProps) => props.theme.colors.gray200};
    }
  }
`

export const CloseButton = styled.div`
  cursor: pointer;
`

export const StyledDarkBackground = styled.div`
  position: fixed;
  z-index: 130;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;

  overflow-y: auto;
  pointer-events: none;
  transition: opacity 0.3s ease-in;

  &[data-show='true'] {
    opacity: 1;
    pointer-events: auto;
  }
`
